import { RoutePlacementsTable, ScopedPlacementsTable } from './PlacementsTableVariants';

export interface PlacementsTableProps {
  demandIntegrationId?: string | undefined;
  publisherId?: string | undefined;
  title?: string | undefined;
  tableLabel?: string | undefined;
  showCreateAction?: boolean | undefined;
}

export function PlacementsTable(props: PlacementsTableProps = {}) {
  return props.demandIntegrationId || props.publisherId ? (
    <ScopedPlacementsTable key={props.demandIntegrationId ?? props.publisherId} {...props} />
  ) : (
    <RoutePlacementsTable {...props} />
  );
}
